/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import AsyncResponseValueStatementCore from '../../../helpers/AsyncResponseValueStatementCore';
import {fileuploadIcon} from "../../../../v1/blocks/WidgetValues/FileUpload";

function defineBlock(context) {
    let prop = {...context};
    prop.tooltipText = "Append a file to a File Upload widget.";
    prop.responseText = "result";
    prop.responseBlockType = "text_response";
    prop.blockColor = Blockly.Msg.WIDGET_VALUES_HUE;
    prop.helpAnchor = '#file-uploads';
    let blockInstance = AsyncResponseValueStatementCore(prop);

    Object.assign(blockInstance, {
        addFields: function () {
            this.appendDummyInput()
                .appendField("append file");
            this.appendValueInput('VALUE')
                .setCheck("String");
            this.appendDummyInput()
                .appendField(" to")
                .appendField(new Blockly.FieldImage(fileuploadIcon, 30, 30, "fileupload icon", null), 'fileuploadIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context, "fileupload", undefined, '- select -'), "ID");
        },

        // keeps the widget icon tooltip in sync alongside the core's response-block bookkeeping
        customChangeHandler: function () {
            if (this.getField('fileuploadIcon')?.imageElement_)
                this.getField('fileuploadIcon').setTooltip('FileUpload control');
        }
    });

    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue('ID');
            let value = Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_NONE) || '""';
            let coreResponseCode = block.getJavascriptCore();
            return `Snap.widgets.fileupload.appendFile({ id: ${JSON.stringify(id)}, fileUrl: ${value} }, ${coreResponseCode});\n`;
        }
    }
}

const AppendFile = function (props) {
    const name = 'snap_append_file_to_fileupload';
    AppendFile.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {
                props.widget?.id === undefined
                    ? null
                    : <field name="ID">{props.widget.id}</field>
            }
            <value name="VALUE">
                <shadow type="text"/>
            </value>
        </block>
    );
}

AppendFile.propTypes = {
    context: PropTypes.object,
    widgets: PropTypes.array,
    widget: PropTypes.object
};

export default AppendFile;
